/**
     * MissionCompleted.contract.ts — Event Contract System™ (generation v1).
     * Reserved publisher: a mission finished. Subscribers are wired and waiting; the production publisher lands with the v2 Mission Engine sprint.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const MissionCompletedContract: EventContract = {
      name: 'MissionCompleted',
      version: 1,
      description: "Reserved publisher: a mission finished. Subscribers are wired and waiting; the production publisher lands with the v2 Mission Engine sprint.",
      publishers: [],
      subscribers: ["module:planner","module:career","module:network","sidebar"],
      fields: [
        { name: 'missionId', type: 'string', required: false, description: "Identifier of the completed mission" },
    { name: 'outcome', type: 'string', required: false, description: "Completion outcome label" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Publish time (Date.now()) at completion.",
      stability: 'reserved',
      deprecated: false,
      example: null,
    };
    